import uniq from "lodash/uniq";
import isNaN from "lodash/isNaN";
import isNumber from "lodash/isNumber";
import includes from "lodash/includes";

export function snapTo(value, values) {
  const [_, cur] = values.reduce((col, cur) => {
    const dif = Math.abs(value - cur);
    if (col === -1) {
      return [dif, cur];
    }

    if (col[0] > dif) {
      return [dif, cur];
    }
    return col;
  }, -1);
  return cur;
}

export function getSearchConfig({
  searchText,
  attributes,
  markets,
  regions,
  slashsheets,
}) {
  const config = {};

  const textSearch = searchText
    ? {
        $or: [
          { title: searchText },
          { excerpt: searchText },
          { content: searchText },
        ],
      }
    : null;

  const checkedRegions = regions
    .filter((r) => r.checked)
    .map((r) => ({ regions: r.title }));
  const checkedAttributes = attributes
    .filter((r) => r.checked)
    .map((r) => ({ "attributes.slug": `=${r.slug}` }));
  const checkedMarkets = markets
    .filter((r) => r.checked)
    .map((r) => ({ "markets.slug": `=${r.slug}` }));
  const checkedSlashsheets = slashsheets
    .filter((r) => r.checked)
    .map((r) => ({ slashsheets: `=${r.slug}` }));

  const $and = [
    ...checkedRegions,
    ...checkedAttributes,
    ...checkedMarkets,
    ...checkedSlashsheets,
  ];

  if (textSearch) {
    $and.push(textSearch);
  }

  if ($and.length) {
    config.$and = $and;
  }

  return config;
}

export function parseDk(dk) {
  // "4.01"
  // "3.38 / 3.45 / 3.60 / 3.75"
  const values = [];
  if (includes(dk, "/")) {
    values.push(...dk.split("/").map((v) => parseFloat(v)));
  } else {
    values.push(parseFloat(dk));
  }
  return values;
}

export function parseDf(df) {
  // "0.0200"
  // "0.0028 - 0.0035"
  const values = [];
  if (includes(df, "-")) {
    values.push(...df.split("-").map((v) => parseFloat(v)));
  } else {
    values.push(parseFloat(df));
  }
  return values;
}

export function getInitialState() {
  const uniqueDkValues = uniq(
    window.isolaData.products
      .flatMap((p) => parseDk(p.dk))
      .filter((v) => !isNaN(v) && isNumber(v))
  );
  const uniqueDfValues = uniq(
    window.isolaData.products
      .flatMap((p) => parseDf(p.df))
      .filter((v) => !isNaN(v) && isNumber(v))
  );

  return {
    primaryMenu: 0,
    secondaryMenu: 0,
    searchText: "",
    searchConfig: {},
    attributes: window.isolaData.attributes,
    markets: window.isolaData.markets,
    regions: window.isolaData.regions.map((r) => ({ title: r, id: r })),
    slashsheets: window.isolaData.slashsheets,
    searchResults: window.isolaData.products,
    tg: 0,
    td: 0,
    dk: Math.max(...uniqueDkValues),
    df: Math.max(...uniqueDfValues),
    uniqueTgValues: uniq(
      window.isolaData.products
        .map((p) => parseFloat(p.tg))
        .filter((v) => !isNaN(v) && isNumber(v))
    ),
    uniqueTdValues: uniq(
      window.isolaData.products
        .map((p) => parseFloat(p.td))
        .filter((v) => !isNaN(v) && isNumber(v))
    ),
    uniqueDkValues,
    uniqueDfValues,
  };
}
